import { createStore, createHook, type StoreActionApi } from '@atlassian/react-sweet-state';
import type { TimelineViewIssue } from '../../types.tsx';

export type IssuesMap = Map<string, TimelineViewIssue>;

type State = {
	issuesMap: IssuesMap;
};

export const actions = {
	setIssuesMap:
		(issuesMap: IssuesMap) =>
		({ setState, getState }: StoreActionApi<State>) =>
			setState({ ...getState(), issuesMap }),
} as const;
type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState: { issuesMap: new Map() },
	actions,
	name: 'JWMTimelineViewIssuesMapStore',
});

export const useIssuesMap = createHook(Store);
